// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TDeleteOfferFromComparisonRequest,
  TDeleteOfferFromComparisonModel,
  IMappers,
  TDeleteOfferFromComparisonResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IDeleteOfferFromComparisonResponse } from '../../entities/delete_offer_from_comparison/DeleteOfferFromComparisonResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createDeleteOfferFromComparisonModel(
  parameters: TDeleteOfferFromComparisonRequest,
): TDeleteOfferFromComparisonModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'offers-comparison',
    pathApi: '/v1/delete-offer-from-comparison/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IDeleteOfferFromComparisonOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TDeleteOfferFromComparisonRequest;
}

export async function fetchDeleteOfferFromComparison<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IDeleteOfferFromComparisonOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TDeleteOfferFromComparisonResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createDeleteOfferFromComparisonModel(parameters),
    config,
  )) as FetchResponse<TDeleteOfferFromComparisonResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IDeleteOfferFromComparisonResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TDeleteOfferFromComparisonResponse>;
}
